const pt = {
  nav_dashboard: 'Painel', nav_inventory: 'Inventário', nav_my_stock: 'Meu Estoque',
  nav_containers: 'Contêineres', nav_requests: 'Solicitações', nav_invoices: 'Faturas',
  nav_payments: 'Pagamentos', nav_settings: 'Configurações', nav_sign_out: 'Sair',
  nav_customers: 'Clientes', nav_employees: 'Equipe', nav_tasks: 'Tarefas',
  nav_scan: 'Escanear', nav_pricing: 'Preços', nav_price_quotes: 'Cotações',
  nav_selection_orders: 'Pedidos de Seleção',
  btn_save: 'Salvar', btn_cancel: 'Cancelar', btn_delete: 'Excluir', btn_edit: 'Editar',
  btn_add: 'Adicionar', btn_submit: 'Enviar', btn_approve: 'Aprovar', btn_reject: 'Rejeitar',
  btn_search: 'Buscar', btn_confirm: 'Confirmar', btn_sign_in: 'Entrar',
  btn_save_changes: 'Salvar Alterações',
  login_title: 'BIG STAR', login_subtitle: 'Gestão de Exportação de Veículos',
  login_username: 'Nome de usuário', login_email: 'E-mail', login_password: 'Senha',
  login_remember: 'Lembrar-me', login_invalid: 'Credenciais inválidas',
  detail_make: 'Fabricante', detail_model: 'Modelo', detail_year: 'Ano',
  detail_chassis: 'Número do Chassi', detail_color: 'Cor', detail_mileage: 'Quilometragem',
  detail_condition: 'Condição', detail_status: 'Status', detail_price: 'Preço', detail_fob: 'Preço FOB',
  status_available: 'Disponível', status_shipped: 'Enviado',
  status_delivered: 'Entregue', status_pending: 'Pendente',
  vehicles: 'Veículos', engines: 'Motores', parts: 'Peças', dashboard: 'Painel',
  add: 'Adicionar', edit: 'Editar', save: 'Salvar', cancel: 'Cancelar', search: 'Buscar',
  noData: 'Sem dados', dash_welcome: 'Bem-vindo, {name}',
  dash_total_fob: 'Valor FOB Total',
  dash_late_night: 'Boa noite', dash_hello: 'Olá',
  dash_subtitle: 'Visão geral da sua frota, peças e embarques — atualizado em tempo real.',
  dash_local_time: 'HORA LOCAL', dash_status: 'STATUS', dash_all_systems_live: 'Todos os sistemas ativos',
  dash_view_recommendations: 'Ver recomendações', dash_my_stock: 'MEU ESTOQUE', dash_in_transit: 'EM TRÂNSITO',
  dash_units: 'unidades', dash_containers: 'contêineres', dash_browse_more: 'Ver mais',
  dash_track_shipments: 'Rastrear embarques', dash_browse_inventory_start: 'Navegue pelo inventário para começar',
  dash_no_active_shipments: 'Nenhum embarque ativo', dash_next_eta: 'Próxima chegada em', dash_days: 'dias',
  dash_etas_confirming: 'Datas de chegada sendo confirmadas', dash_this_week: 'ESTA SEMANA',
  dash_arriving_soon: 'CHEGANDO EM BREVE', dash_logistics: 'LOGÍSTICA', dash_active_shipments: 'Embarques ativos',
  dash_view_all: 'Ver todos', dash_shipment_empty: 'Seu próximo embarque aparecerá aqui quando as unidades forem carregadas em um contêiner',
  dash_composition: 'COMPOSIÇÃO', dash_stock_breakdown: 'Detalhamento do estoque', dash_no_units_yet: 'Nenhuma unidade ainda',
  dash_browse_to_build: 'Navegue pelo inventário para montar seu estoque',
  dash_for_you: 'PARA VOCÊ', dash_picked_based: 'Selecionado com base no seu estoque', dash_browse_all: 'Ver tudo',
  dash_picking_units: 'Estamos selecionando unidades para você. Volte em breve ou navegue por todo o inventário',
  dash_view_details: 'Ver detalhes', dash_just_arrived: 'RECÉM-CHEGADO', dash_similar: 'SEMELHANTE AO SEU',
  dash_today: 'Hoje', dash_tomorrow: 'Amanhã',
};
export default pt;
